import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Views } from "../../api/views";
import { Context } from "../../context";
import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

function ViewsSelector(_: Props) {
  const { currentView, selectView } = React.useContext(Context);
  const { t } = useTranslation();

  return (
    <VisibilityWatcher className={styles.viewsSelector}>
      {(isVisible, show, hide) => (
        <React.Fragment>
          <div
            className={classNames(styles.input, { [styles.open]: isVisible })}
            onClick={isVisible ? hide : show}
          >
            <p>
              {currentView === Views.DAILY
                ? t("projectPage.ganttPage.viewSelection.daily")
                : currentView === Views.MONTHLY
                  ? t("projectPage.ganttPage.viewSelection.monthly")
                  : currentView === Views.YEARLY
                    ? t("projectPage.ganttPage.viewSelection.yearly")
                    : t("projectPage.ganttPage.viewSelection.weekly")}
            </p>
            <ToggleArrow className={styles.icon} />
          </div>
          {isVisible && (
            <div className={styles.list}>
              {/* Daily view (hourly columns) is built but not ready to ship.
                  This option is the only entry point — uncomment to
                  re-enable, and give viewSelection.weekly back its
                  "Weekly view" / "Vue hebdomadaire" labels so the two
                  options don't read the same. */}
              {/* {currentView !== Views.DAILY && (
                <p
                  className={styles.item}
                  onClick={() => selectView(Views.DAILY)}
                >
                  {t("projectPage.ganttPage.viewSelection.daily")}
                </p>
              )} */}
              {currentView !== Views.WEEKLY && (
                <p
                  className={styles.item}
                  onClick={() => selectView(Views.WEEKLY)}
                >
                  {t("projectPage.ganttPage.viewSelection.weekly")}
                </p>
              )}
              {currentView !== Views.MONTHLY && (
                <p
                  className={styles.item}
                  onClick={() => selectView(Views.MONTHLY)}
                >
                  {t("projectPage.ganttPage.viewSelection.monthly")}
                </p>
              )}
              {currentView !== Views.YEARLY && (
                <p
                  className={styles.item}
                  onClick={() => selectView(Views.YEARLY)}
                >
                  {t("projectPage.ganttPage.viewSelection.yearly")}
                </p>
              )}
            </div>
          )}
        </React.Fragment>
      )}
    </VisibilityWatcher>
  );
}

export { ViewsSelector };
